import React, { Suspense, useEffect, useState } from 'react'
import styles from "./HomeLayout.module.scss"
import { Outlet, useLocation } from 'react-router-dom';
import LeftSideBar from './LeftSideBar';
import SearchBar from './SearchBar';
import { useDispatch, useSelector } from 'react-redux';
import { Loader } from 'components/shared/loader/Loader';
import TopBar from './TopBar';
import { getStock, setModal, setRole } from 'redux/stockSlice';

const HomeLayout = () => {
    const location = useLocation()
    const dispatch = useDispatch()
    const [show, setShow] = useState(false)

    const { load, roles } = useSelector((state) => state.stock)
    // function handleshow(fun) {
    //     if (fun) {
    //         fun('')
    //     }
    // }
    useEffect(() => {
        let role = JSON.parse(localStorage.getItem("permission"))
        dispatch(setRole(role))
        // dispatch(getStock())
    }, [])
    return (
        <div className={styles.layout}
            onClick={() => {
                dispatch(setModal(false))
            }}
        // onClick={() => {
        //     setShow(false)
        //     handleshow()
        // }
        // }
        >
            <LeftSideBar />
            <div className={styles.rightSideContainer}
            >
                {/* {
                    location.pathname == "/stock" || location.pathname == "/stock/logs" ? null : <TopBar />
                } */}
                <TopBar />
                {/* {
                    location.pathname == "/stock" ? null : <SearchBar show={show} setShow={setShow} handleshow={handleshow} />
                } */}
                {
                    load && location.pathname == "/stocktrend" && <Loader />
                }
                <div className={styles.outletDiv}>
                    <Suspense fallback={<Loader />}>
                        <Outlet />
                    </Suspense>
                </div>

            </div>
        </div>
    );
}

export default HomeLayout;